/**
 * Small accessibility repairs for third-party embeds (VG-016).
 *
 * The Google merchant badge, the Shopify web-pixel sandbox and the Razorpay checkout all inject
 * <iframe> elements with no title attribute, which screen readers announce as an unlabelled
 * frame. We cannot change their markup, but we can name them once they appear.
 */
(function () {
  var NAMES = [
    [/merchantverse|merchantwidget/i, 'Google customer reviews badge'],
    [/razorpay/i, 'Secure payment window'],
    [/web-pixels?/i, 'Analytics (no visible content)'],
    [/youtube|vimeo/i, 'Video player']
  ];

  function titleFrame(frame) {
    if (!(frame instanceof HTMLIFrameElement) || frame.title) return;
    var src = frame.getAttribute('src') || '';
    for (var i = 0; i < NAMES.length; i++) {
      if (NAMES[i][0].test(src)) {
        frame.title = NAMES[i][1];
        return;
      }
    }
    // An unrecognised frame still needs a name; hide it from the tree if it has no content.
    frame.title = 'Embedded content';
  }

  function sweep(root) {
    (root.querySelectorAll ? root.querySelectorAll('iframe') : []).forEach(titleFrame);
  }

  sweep(document);

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'IFRAME') titleFrame(node);
        else sweep(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
